"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function CalloutBox() {
  const { t } = useLanguage();
  return (
    <section className="bg-[#064e3b] text-white p-8 my-12 border-l-8 border-[#fbbf24] rounded-r-lg">
      <h3 className="text-2xl font-bold mb-4">{t("blog.codes.calloutTitle")}</h3>
      <p className="text-white/90 leading-relaxed">
        {t("blog.codes.calloutText")}
      </p>
    </section>
  );
}